import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { Box, Typography, Stack } from '@mui/material'
import Input from 'components/generic/form/Input'
import Select from 'components/generic/form/Select'
import { COMMODITY_TYPE, COMMODITY_CLASS } from 'utils/constants'
import { useEffect } from 'react'

const GeneralPropertiesForm = ({
  commodityData,
  distinctCommodityTypes,
  commodityNameDuplicated,
  commodityCodeDuplicated,
}) => {
  const [isCustomType, setIsCustomType] = useState(false)
  const {
    control,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext()

  const general = watch('general')

  useEffect(() => {
    if (general.class !== COMMODITY_CLASS.OTHER) {
      setValue('general.type', general.class)
      clearErrors('general.type')
    } else if (general.class === COMMODITY_CLASS.OTHER) {
      if (commodityData?.class !== COMMODITY_CLASS.OTHER) {
        setValue('general.type', '')

        const typeInput = document.querySelector('input[name="general.type"]')
        if (typeInput) {
          typeInput.focus()
        }
      } else {
        setValue('general.type', commodityData.type)
        clearErrors('general.type')
      }
    }
  }, [general.class])

  return (
    <Stack key="general-properties" flexGrow={1} ml={4}>
      <Typography variant="h5">General Properties</Typography>
      <Stack mt={3} spacing={2}>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Input
            name="general.name"
            label="Name of Commodity"
            data-test="general-commodity-name"
            defaultValue=""
            control={control}
            error={commodityNameDuplicated ? true : !!errors?.general?.name}
            helperText={
              commodityNameDuplicated ? 'This commodity name is already in use' : errors.general?.name?.message
            }
          />
        </Box>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Stack direction="row" spacing={2}>
            <Box width={general.class === COMMODITY_CLASS.OTHER ? '50%' : '100%'}>
              <Select
                name="general.class"
                label="Commodity Type"
                control={control}
                variant="outlined"
                items={COMMODITY_TYPE}
                error={!!errors?.general?.class}
                helperText={errors.general?.class?.message}
              />
            </Box>
            {general.class === COMMODITY_CLASS.OTHER && (
              <Box width="50%">
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  {isCustomType ? (
                    <Input
                      name="general.type"
                      label="Create a new type..."
                      control={control}
                      variant="outlined"
                      error={!!errors?.general?.type}
                      helperText={errors.general?.type?.message}
                      sx={{ flexGrow: 1 }}
                    />
                  ) : (
                    <Select
                      name="general.type"
                      label="Select a type..."
                      control={control}
                      variant="outlined"
                      items={
                        distinctCommodityTypes ? distinctCommodityTypes.map(type => ({ id: type, name: type })) : []
                      }
                      error={!!errors?.general?.type}
                      helperText={errors.general?.type?.message}
                      sx={{ flexGrow: 1 }}
                    />
                  )}
                  {/* TODO: Add back in when we have a use case for creating custom types */}
                  {/* <Tooltip title={isCustomType ? 'Switch back to dropdown' : 'Add custom type'}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setIsCustomType(!isCustomType)
                        if (!isCustomType) {
                          setTimeout(() => {
                            document.querySelector('input[name="general.type"]')?.focus()
                          }, 0)
                        } else {
                          setValue('general.type', '')
                        }
                      }}
                      sx={{
                        top: '10px',
                      }}
                    >
                      {isCustomType ? <CloseIcon /> : <AddCircleIcon />}
                    </IconButton>
                  </Tooltip> */}
                </Stack>
              </Box>
            )}
          </Stack>
        </Box>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Input
            name="general.code"
            label="Commodity Code"
            data-test="general-commodity-code"
            defaultValue=""
            control={control}
            error={commodityCodeDuplicated ? true : !!errors?.general?.code}
            helperText={
              commodityCodeDuplicated ? 'This commodity code is already in use' : errors.general?.code?.message
            }
          />
        </Box>
      </Stack>
    </Stack>
  )
}
GeneralPropertiesForm.propTypes = {
  commodityNameDuplicated: PropTypes.bool,
  commodityCodeDuplicated: PropTypes.bool,
}

GeneralPropertiesForm.defaultProps = {
  commodityNameDuplicated: false,
  commodityCodeDuplicated: false,
}

export default GeneralPropertiesForm
